import { render, staticRenderFns } from "./InheritRoles.vue?vue&type=template&id=febd4f1c"
import script from "./InheritRoles.vue?vue&type=script&lang=js"
export * from "./InheritRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports